import { PiGlobeThin } from 'react-icons/pi';

import AvatarCircle from '../AvatarCircle';
import { OSearchableDropdown } from '@src/shared';

import useClosedCaptions from './useClosedCaptions';

import { TRANSLATION_LANGUAGES } from './closedCaptions.constants';

import classes from './ClosedCaptions.module.scss';

const ClosedCaptions = () => {
  const { speakers, containerRef, selectedLanguage, closedCaptionsError, onChangeLanguage } = useClosedCaptions();

  return (
    <div className={classes.closedCaptionsContainer}>
      <OSearchableDropdown
        highlightSelected
        items={TRANSLATION_LANGUAGES}
        onChange={(languageId) => {
          onChangeLanguage(String(languageId));
        }}
        className={classes.languageDropdown}
        selectedValue={selectedLanguage}
        selectedIcon={<PiGlobeThin size={20} color="white" />}
      />
      <ul ref={containerRef} className={classes.captionsList}>
        {closedCaptionsError === 'TRANSCRIPTION_TEMPORARILY_UNAVAILABLE' && (
          <div className={classes.transcriptionNotice}>
            <h2>Transcription temporarily unavailable</h2>
            <p>We’re working to restore captions shortly. Thanks for your patience.</p>
          </div>
        )}
        {speakers.map(({ peer_id, peer_name, lines, isTyping, isFinal }, idx) => (
          <li key={`${peer_id}-${idx}`} className={classes.twoLineCaptions}>
            <AvatarCircle peerId={peer_id} avatarImgSize={42} />
            <div className={classes.captionsContainer}>
              <p className={classes.captionsName}>{peer_name}</p>
              <div className={classes.captionsText}>
                {lines.map((ln, i) => (
                  <div key={i}>
                    {ln}
                    {!isFinal && isTyping && i === lines.length - 1 && <span className="pulse"> |</span>}
                  </div>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ClosedCaptions;
